export default __webpack_public_path__ + "static/media/vehicle@2x.235ede76.png";